import React from 'react'
import { sizes } from './const'

export interface PrintIconProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analytics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon
     * */
    color?: 'white' | 'black'
}

export const PrintIcon = ({
    className = '',
    size = 'medium',
    color = 'black',
}: PrintIconProps) => {
    return (
        <svg
            className={`js_PrintIcon mb-1 ${className} ${sizes[size]}`}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.6667 18.6667V28H9.33337V18.6667H22.6667Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.6667 4V12H9.33337V4H22.6667Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.33333 24H4V12H28V24H22.6667"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
